export interface Player {
  x: number;
  y: number;
  angle: number;
  health: number;
  cooldown: number;
}

export interface Ball {
  x: number;
  y: number;
  vx: number;
  vy: number;
  radius: number;
}

export interface Explosion {
  x: number;
  y: number;
  timer: number;
  maxTimer: number;
}

export interface DodgeballGame {
  p1: Player;
  p2: Player;
  balls: Ball[];
  frozenBalls: Ball[];
  explosions: Explosion[];
  winner: number | null;
  message: string;
}

export const CANVAS_W = 800;
export const CANVAS_H = 500;
export const WALL_TOP = 20;
export const WALL_BOTTOM = CANVAS_H - 20;
export const PLAYER_RADIUS = 16;
export const BALL_RADIUS = 8;
export const BALL_SPEED = 320;
export const MAX_HEALTH = 10;
